import { BreadcrumbGroup, SegmentedControl, SpaceBetween } from '@cloudscape-design/components';
import { GoogleMap, Polygon, useJsApiLoader } from '@react-google-maps/api';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { buildBreadcrumbItems, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';

const containerStyle = {
  width: '100%',
  height: '100%', // Set map height to 100% of its parent (.map-wrapper)
};

const center = {
  lng: -70.59,
  lat: -33.332,
}

type ItemPath = {
  lat: number;
  lng: number;
}


export const MembersEDVZonesPage = () => {
  // IMPORTANTE: Asegúrate de reemplazar esta clave con la tuya real en un entorno de producción
  const API_KEY = 'AIzaSyArNTcY1e_oLKgply89Mx2NySzONuIsYYc';
  const { menu } = useGlobalState();

  // Hook para manejar la carga de la API
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: API_KEY,
  });
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const urls = {
    riscos: "https://store.planeadores.cl/documents/zones/riscos.kml",
    cobre: "https://store.planeadores.cl/documents/zones/cobre.kml",
    precordillera: "https://store.planeadores.cl/documents/zones/precordillera.kml"
  };
  const [selectedId, setSelectedId] = React.useState("riscos");
  const [paths, setPaths] = React.useState<ItemPath[]>([]);

  const onLoad = useCallback(function callback(map: any) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map: any) {
    setMap(null);
  }, []);

  // Opciones del mapa: Aquí se define el zoom inicial (14)
  const options = useMemo(() => ({
    //zoom: 1, // Zoom inicial correcto
    zoomControl: true,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
  }), []);
  type UrlKeys = keyof typeof urls;
  useEffect(() => {
    if (selectedId) {
      const urlKey = selectedId as UrlKeys;
      //console.log(urls[urlKey]);
      handleGetURL(urls[urlKey]);
    }
  }, [selectedId]);
  useEffect(() => {
    if (paths && map && isLoaded) {
      const bounds = new window.google.maps.LatLngBounds();
      paths.forEach(path => {
        // Asegúrate de usar 'window.google.maps.LatLng' ya que viene de la API de Google Maps
        bounds.extend(new window.google.maps.LatLng(path.lat, path.lng));
      });
      map.fitBounds(bounds);
    }
  }, [paths, map, isLoaded]);
  const handleGetURL = async (url: string) => {
    //console.log("handleGetURL", url);
    try {
      setLoading(true)
      const response = await fetch(url, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.text();
      if (dataWeb) {
        setPaths(parseKMLCoordinates(dataWeb));
      }
    } catch (error: any) {
      console.error("Error de red y/o comunicaciones: ", error);
    } finally { setLoading(false) }
  }
  return (<CustomAppLayout
    toolsHide

    contentType="form"
    breadcrumbs={
      <BreadcrumbGroup
        items={buildBreadcrumbItems(menu)}
        expandAriaLabel="Show path"
        ariaLabel="Breadcrumbs"
      />
    }



    content={
      isLoaded ? (
        <SpaceBetween size="s" >
          <div className="main-content-layout"
            style={{
              height: 'calc(100vh - 150px)',
              display: 'flex',
              flexDirection: 'column',

            }}
          >
            <SegmentedControl
              selectedId={selectedId}
              onChange={({ detail }) =>
                setSelectedId(detail.selectedId)
              }
              label="Zonas de vuelo"
              options={[
                { text: "Riscos", id: "riscos" },
                { text: "Cobre", id: "cobre" },
                { text: "Precordillera", id: "precordillera" }
              ]}
            />
            <div className="map-wrapper" style={{
              flexGrow: 1,
              minHeight: 0,
            }}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                onLoad={onLoad}
                onUnmount={onUnmount}
                options={options}
              // Si usaras el estado para controlar el zoom: zoom={currentZoom}
              >
                {/* Componente del Polígono */}
                <Polygon
                  paths={paths}
                  options={{
                    strokeColor: '#007bff', // Azul
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                    fillColor: '#007bff',
                    fillOpacity: 0.25,
                  }}
                />
              </GoogleMap>
            </div>
          </div >

        </SpaceBetween >
      ) : (<></>)
    }
  />)
};




const parseKMLCoordinates = (kmlString: string) => {
  try {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(kmlString, "text/xml");

    // Buscamos el elemento <coordinates> dentro del primer <Polygon>
    const coordinatesElement = xmlDoc.querySelector('Placemark Polygon coordinates');

    if (!coordinatesElement) {
      console.error("No se encontraron coordenadas de polígono en el KML.");
      return [];
    }

    const coordsText = coordinatesElement.textContent.trim();

    // El KML separa los puntos por espacios y las coordenadas por comas (LNG, LAT, ALT)
    const coordPairs = coordsText.split(/\s+/).filter(c => c.length > 0);

    return coordPairs.map(coord => {
      const parts = coord.split(',');

      // KML usa Longitud (parts[0]), Latitud (parts[1]), Altitud (parts[2], ignorada)
      const lng = parseFloat(parts[0]);
      const lat = parseFloat(parts[1]);

      if (isNaN(lat) || isNaN(lng)) {
        console.warn("Par de coordenadas inválido encontrado:", coord);
        return null;
      }

      return { lat, lng };
    }).filter(c => c !== null); // Filtramos cualquier coordenada inválida

  } catch (e) {
    console.error("Error al parsear KML:", e);
    return [];
  }
};